import Vue from "vue";

export const collapseJSReactive = Vue.observable({ value: [] });

export default {
  get() {
    return collapseJSReactive.value;
  },
  set(active) {
    collapseJSReactive.value = active;
  },
};
